import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './index.scss';
import { loadRuntimeConfig } from './app/config/runtimeConfig';

const bootstrap = async () => {
  await loadRuntimeConfig();
  await import('./i18n');

  const { default: AppRouter } = await import('./router/approuter');
  const { store } = await import('./app/store/store');
  const { default: reportWebVitals } = await import('./reportWebVitals');

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

bootstrap();
